<template>
  <div style="padding-left: 10px; padding-right: 10px">
    <p style="text-align:center">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >隐私政策</span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >本政策将帮助您了解以下内容：</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >一、我们如何收集和使用您的个人信息</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >二、您如何管理您的个人信息</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >三、我们如何共享、转让、公开披露您的个人信息</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >四、我们如何存储和保护您的个人信息</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >五、未成年人隐私权特别约定</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >六、第三方责任说明</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >七、本政策适用与修订</span
      >
    </p>
    <p style="text-align:left;text-indent:28px">
      <a name="_GoBack"></a
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >大衍深知个人信息对您的重要性，并会尽全力保护您的个人隐私信息安全可靠。我们致力于维持您对我们的信任，保护您的个人信息，恪守权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等要求。同时，承诺，我们将遵守并落实《网络安全法》的各项规定，依照业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请您在使用我们的产品或服务前，仔细阅读本《隐私政策》，尤其是<strong>划线或加粗</strong>内容，了解我们对您个人信息的处置原则和保护措施。阅读过程中，如您有任何疑问或任何投诉意见，请与我们的客服、联系咨询。<strong
          ><span style="text-decoration:underline;"
            >如您不同意协议中的任何发布或修订的条款，您可选择停止注册或注销账户，同时您应知晓，将无法再为您提供相关服务。</span
          ></strong
        ></span
      >
    </p>
    <p style="text-indent:28px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >本隐私政策中涉及的个人敏感信息，主要是用于电商服务的用户鉴别与授权信息，及在支付业务中收集、存储的，可识别特定自然人身份，以及金融消费者用于支付等业务的关键信息，支付机构用于内部使用的信息资产信息。此类信息经过组合、关联和分析后可能产生高敏感程度的信息，遭到未经授权的查看或未经授权的变更，会对支付等金融消费主体的个人信息安全与财产安全造成严重危害，包括但不限于：</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >身份基本信息：</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >包括客户姓名、国籍、民族、性别、职业、住址、联系方式、婚姻状态、职业信息、手写签名、紧急联系人信息，以及客户有效身份证件的种类、号码、有效期限、签发机关及其正反面影印件</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >网络身份标识信息：</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >包括系统账号、IP地址、邮箱地址及与前述有关的密码、密码保护问题及其答案。</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >个人常用设备信息：</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >包括硬件型号、设备MAC地址、操作系统类型、IP地址、可变更设备识别码（如Android
            ID、IDFA、IDFV等在内的描述个人常用设备基本情况的信息）。</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >生物识别信息：</span
          ></span
        ></strong
      >
    </p>
    <p style="text-align:left">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >面部特征、语音信息。</span
          ></span
        ></strong
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >一、我们如何收集和使用您的个人信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >为了您可以正常使用服务，下列情形下您需要向我们提供相关信息：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（一）实名注册</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、当您通过、官方门户、小程序注册账户或使用服务时，需要按照《非银行支付机构网络支付业务管理办法》的要求，提供您的<strong>姓名、国籍、性别、职业、住址、联系方式、有效身份证件的号码和有效期限以及绑定的银行卡信息（需要验证银行卡卡号、身份证号码、银行预留手机号、手机验证码）</strong>。<strong
          ><span style="text-decoration:underline;"
            >如您未能提供上述信息，即未完成实名制验证，将无法注册账户或无法进行支付交易。同时为了验证该类信息的准确性和完整性，我们会将您提供的信息与合法传送至存有您信息的第三方机构（如政府机关、事业单位、商业银行、合法设立的商业化数据库等）进行实名制验证，我们会对该类验证机构提供的信息来源合法性进行稽核。</span
          ></strong
        ></span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、因根据《支付机构反洗钱和反恐怖融资管理办法》等反洗钱相关法律、法规、规章及其他规范性文件要求，还需要您补充提供<strong>有效身份证件的彩色影印件</strong>以供我们核对并留存；如您未能提供，我们将无法为您注册账户或向您继续提供支付服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（二）支付服务</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、账户余额支付</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >为了您能使用账户余额支付服务进行消费、转账以及购买产品，我们需要记录您的<strong>账户余额信息以及交易信息</strong>。如您不同意我们记录前述信息，可能无法使用余额支付服务，但不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、快捷支付</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >为了您能使用快捷支付服务，实现使用银行卡对账户余额的充值、提现以及基于银行卡的消费、转账及购买投资理财等金融类产品，您需提供您的<strong>银行卡卡号、身份证号码、银行预留手机号、手机验证码</strong>。我们会将前述信息与发卡银行进行验证。在您使用快捷支付服务时，我们需要记录您的<strong>交易信息</strong>。如您不提供前述信息，可能无法使用快捷支付服务，但不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p style="text-indent:28px">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >我们承诺收集的支付信息依照中国银联《银联卡支付信息安全管理标准》要求，仅用于完成银联卡交易服务，不得用于除此之外的任何其他用途。</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、转账</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >为了准确执行您的支付指令，在您向他人的账户转账时，您可按照页面提示输入<strong>收款人账户、收款人部分姓名、转账金额，</strong>也可通过<strong>读取通讯录</strong>选择收款人账户。如您不提供<strong>读取通讯录权限</strong>，您仍可通过直接输入收款人信息使用我们提供的转账服务；如您不提供收款人信息，转账可能无法进行，但不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、消费</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >当您在商家进行消费时，我们需要按照法律法规及监管规定对商家进行管理，防范套现或欺诈风险，因此，我们将直接收集或向商家收集您的交易信息，包括<strong>交易金额、交易对象、交易商品、交易时间</strong>。如您不同意我们记录前述信息，则可能无法完成交易，但不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >在使用二维码支付业务时，您可以选择开启<strong>手机的相机权限，使用摄像头设备扫一扫二维码</strong>完成付款服务，如您不提供前述权限，可能无法使用二维码支付服务，但不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >5</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、卡充值账户</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >当您使用卡充值账户时，我们需要您提供<strong>卡卡号、卡密码及充值金额；</strong>如您无法提供上述信息，可能无法完成充值服务，但不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >6</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、客户服务</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >我们会收集您使用<strong>客户服务时的搜索记录、</strong>您与客户服务团队联系时提供的信息及您参与问卷调查时向我们发送的信息。如您不提供前述信息，不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >7</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、年度账单</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >当您使用年度账单服务时，您需按照页面提示打钩，同意授权我们分析您近一自然年的<strong>登录日志、交易记录、理财收益、营销优惠信息</strong>，并可依据您的操作选择将您的年度账单海报分享至社交网络，我们不会将您的年度账单信息提供给第三方使用；如您不提供前述授权，我们将无法展示您的年度账单海报，但不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（三）支付安全</span
      >
    </p>
    <p style="text-indent:28px">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >为了准确预防钓鱼欺诈，保障您的账户安全，防范社会工程化攻击，提高支付交易服务的安全性，我们会通过了解您的设备信息、交易信息、地理位置、服务相关的日志信息来判断您的账号风险，排查并防范您的信息泄露和资金损失风险，并分析处理相关支付系统稳定性和兼容性问题。在必要时需要您通过选择人脸身份识别、支付密码验证等方式来核验本次操作系您本人完成。若您未能通过此次校验，我们将会采取阻断交易、冻结余额等措施保护账户资金安全，您可以通过人工客服申诉本次操作确实系您本人所为。</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（四）个性化服务</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >我们会收集您使用服务时的交易信息、浏览信息、关注信息，进行数据统计分析，形成群体特征的用户画像，以便为您提供您感兴趣的个性化服务，如果您希望退订我们从短信渠道、电话渠道推送的商业广告，可以通过短信回复原号码TD和明确表达不接受此类外呼的方式申请退订服务。我们基于各种业务场景向您推送的账户动态、营销返利、应用服务消息，您也可通过客户端【消息中心】页签消息中的【设置】菜单，开启消息免打扰功能关闭此类消息推送。<strong
          >我们不会以任何方式和途径向您推送涉及隐私内容的商品服务信息，未经您明确授权我们不会出于满足第三方的营销需求而将您的个人信息提供给任何第三方。</strong
        ></span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（五）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、与国家安全、国防安全有关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、与公共安全、公共卫生、重大公共利益有关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、与犯罪侦查、起诉、审判和判决执行等有关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >5</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、所收集的个人信息是个人信息主体自行向社会公众公开的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >6</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >7</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、根据您的要求签订合同所必需的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >8</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >9</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、为合法的新闻报道所必需的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >10</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >11</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、法律法规规定的其他情形。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >二、您如何管理您的个人信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、您可通过门户网站登录账户，点击【我的】跳转【个人信息】，查阅您的身份、账户信息，或修改您的个人资料，如更换头像、账户手机号、账户邮箱地址，修改昵称、职业分类、联系地址，重新上传更新和认证您的身份证件信息，但出于安全性和身份识别的考虑或根据法律法规的强制规定，您可能无法修改注册时提供的初始认证信息。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、您可在门户网站登录账户，在【我的-个人中心-我的银行卡管理】中，以及从客户端登录账户，在【我的】页签银行卡入口中对绑定的银行卡进行管理，如删除既有绑定银行卡、增加绑定银行卡。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、您可通过如下路径注销账户：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（1）客服电话路径：请您用账户绑定的手机号联系我们，核实账户信息后，我们将会在3个工作日内为您完成销户。</span
      >
    </p>
    <p>
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size: 12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >4</span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >、在您仔细阅读《账户注销协议》，并选择注销您的账户后，您该账户内的所有信息将被清空，我们将不会再收集、使用或共享与该账户相关的个人信息，但之前的信息我们仍需按照国家监管要求进行强加密保存，且在该依法保存的期间受有权机关指令，提供有权机关查询，保存周期及超期处置方式请阅读“我们如何存储和保护您的个人信息”章节。</span
          ></span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >5</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、如您发现我们采集、使用您个人信息的行为，违反了法律法规规定或违反了与您的约定，您可联系客服，要求删除该违反行为下采集的您的个人信息，如您在约定外要求删除的，可能会造成对您提供服务的影响或停止。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >6</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、如您发现我们收集、储存的您的个人信息有错误的，或者您本人的个人认证信息发生变更的，可以联系我们的客服或通过在线客服要求更正。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >7</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、在响应您上述5、6项要求前，为保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，验证通过后将在三个工作日内处理完成；有特殊情形的，将在不超过法律法规规定期限内答复您的请求。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >8</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、如果我们停止运营某一产品或者服务，我们将及时停止收集和使用您的个人信息，同时将停止运营的通知通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知您，我们将在法律、行政法规规定的必需期限到期后，对保存的个人信息进行匿名化处理或删除。当我们发现我们控制的个人信息发生或者可能发生泄露、毁损、丢失的情形，将会立即启动应急预案，采取补救措施消减影响和控制损失，并将事件相关情况及时通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知您。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >9</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、尽管有上述约定，但按照法律法规要求，在以下情形下，我们可能无法响应您的请求：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >(1)</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >与国家安全、国防安全有关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >(2)</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >与公共安全、公共卫生、重大公共利益有关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >(3)</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >与犯罪侦查、起诉和审判等有关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >(4)</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >有充分证据表明您存在主观恶意或滥用权利的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >(5)</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >响应您的请求将导致其他个人、组织的合法权益受到严重损害的。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >三、我们如何使用 Cookie：</span
        ></strong
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >为使您获得更轻松的访问体验，我们可能会在您享受个性化服务的同时，向您的计算机或移动设备上发送一个或多个Cookie的小数据文件，指定给您的Cookie是唯一的，它只能被将Cookies发布给您域中的Web服务器读取。您接受的Cookies存储您的浏览习惯和偏好设置等数据，进而帮助判断您的登录状态以及账户或数据安全，优化您对广告的选择与互动，您可以修改浏览器相关设置，以关闭Cookie的使用或删除存储的Cookies，但可能会影响您使用提供的支付服务或安全保障。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >四、我们如何共享、转让、公开披露您的个人信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（一）共享</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >我们仅基于产品与/或服务的业务场景，部署第三方插件或代码，与第三方共享您的信息，第三方包括关联公司、外部实名信息验证机构、合作的金融机构以及其他合作伙伴。我们会按照法律法规及相关国家标准要求，以弹框提示、确认授权、电子协议等多种形式征得您的同意，或确认第三方已征得您的同意，<strong>您可以授权通过服务器后台传输共享您的个人信息（如手机号、昵称、头像、账户余额）便于免密登录访问或创建第三方电商网站账户</strong>，同时在客户端【我的】页签【设置】菜单的【账户与隐私】中提供了授权管理的功能，您可以查询共享信息的第三方机构身份和信息内容，有权选择撤回同意，控制分享信息的范围，针对关闭授权服务的第三方我们将不再共享您的相应个人信息。但请您注意，但您关闭授权撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理，这些信息仍可能由不受我们控制的第三方独立保存，对于我们与之共享信息的第三方，我们会在完成并通过针对第三方的信息安全风险评估后，与其签署必要的保密协定，要求他们严格遵守相关法律法规与监管要求，遵照隐私政策采取保密和安全措施来处理个人信息，未经您的授权严禁用于营销活动或其他处理活动。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、我们提供的第三方产品与/或服务，可能由第三方提供或第三方联合我们提供，因此只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务。
        例如：您使用我们的生活缴费服务时，我们需要把您填写的户号和加油卡号等信息提供给合作的公共事业单位，才能使您完成缴费；您通过使用金融产品时，我们需要依据金融产品所属行业的监管法律法规要求，<strong>提供您的有效证件信息及其正反面影印件、人脸识别信息、婚姻状态、职业信息、手写签名、联系方式、紧急联系人相关信息、收入信息、中国纳税人声明，</strong>以保证您完成购买流程合规性要求以及保证您的资产准确无误的登记；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须情况进行提供；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、在法律法规允许且不违背公序良俗的范围内，为维护、的关联方、您或其他用户或社会公共利益、财产或安全免遭损害而有必要提供，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。我们的关联方无权将个人信息共享用于任何其他用途，我们的关联方如要改变个人信息的处理目的，将再次通过公告公示、弹框授权等方式，征求您的授权同意；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、应您需求为您处理您与他人的纠纷或争议；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（二）转让</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、事先获得您明确的同意或授权；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、在涉及收购、兼并、重组、资产转让或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束。如变更个人信息使用目的时，我们将要求该公司、组织重新向您征求授权同意。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（三）公开披露</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >原则上我们不会将您的信息进行公开披露，但以下情形除外：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、根据您的需求，在您明确同意或授权的披露方式下披露您所指定的个人信息；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、根据法律法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式，在法律法规许可的前提下，采取符合业界标准的安全防护措施的前提下公开披露您的个人信息。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >五、我们如何存储和保护您的个人信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、遵照《网络安全法》规定，我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，我们在境外提供的扫码支付产品，使用支付标记化技术保障支付信息的安全性，在当地未留存个人信息。作为持有支付业务许可证的支付机构，当您注销您的账户后，我们将会按照《支付机构反洗钱和反恐怖融资管理办法》规定的期限，保存您的身份资料、交易记录为期五年，超出期限后将对您的个人信息进行匿名化处理或删除。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、在发放代金券、返利权益金、积分、早起打卡随机瓜分奖金业务场景中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些觉得显著影响您的合法权益，您有权提出申诉要求我们做出解释，我们也将提供适当的补偿控制措施。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、我们已使用符合业界标准的安全防护措施保护您提供的个人信息，采取措施保护数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，确保您个人信息的安全性、完整性、真实性、有效性。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >六、未成年人隐私权特别约定</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >若您是18周岁以下未成年人，请您的父母或监护人阅读本政策，并在征得的您父母或监护人同意的前提下使用我们的服务或向我们提供您的信息，根据国家相关法律法规的规定要求保护未成年人的个人信息。<strong
          ><span style="text-decoration:underline;"
            >如您的父母或监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。若您是不满14周岁的儿童，依据《儿童个人信息网络保护规定》制定如下儿童个人信息网络保护特别条款，请您和您的父母或监护人仔细阅读。我们承诺当收集、存储、使用、转移、披露儿童个人信息时，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，并以显著、清晰的方式告知您的父母或监护人征得其同意。</span
          ></strong
        ></span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（一）我们如何征得儿童的父母或监护人授权同意：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、当您登录账户时，您需要完成必要的身份信息认证步骤，并通过核验后方能完成账户实名：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（1）请您和您的父母或监护人仔细阅读《服务协议》和《隐私政策》中涉及儿童个人信息保护的特别条款，并通过勾选协议征得您的父母或监护人授权同意；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（2）请填写您的户口簿相关登记信息，包括<strong>您的姓名、身份证号、性别、联系地址以及职业</strong>；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（3）请经得您的父母或监护人授权同意，上传您的<strong>父母或监护人有效身份证的彩色影印件</strong>，并通过实名制验证；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（4）请证明您和您的父母或监护人的监护关系，包括上传您的<strong>户口簿户主页、监护人信息页以及儿童本人信息页</strong>，并提交审核；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、当我们针对特别条款的告知事项发生实质性变化时，我们将再次征询您的父母或监护人的授权同意，请您的父母或监护人阅读“本政策适用与修订”章节，具体了解涉及变化的范围和我们采取的措施；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、建议您将特别条款及身份认证要求，与您的父母或监护人分享，若您或您的父母或监护人，对您的儿童个人信息有相关疑问时，请阅读“如何联系我们”章节，与的儿童个人信息保护专人进一步沟通。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >（二）我们如何处置停止服务和应急响应事件：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、当我们停止运营某一产品或者服务时，会将停止运营的通知及时通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知儿童的父母或监护人，并立即停止收集这类产品或服务涉及的儿童个人信息，我们将在法律、行政法规规定的必需期限到期后，对这类产品或服务涉及的儿童个人信息进行匿名化处理或删除；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、当我们发现我们控制的儿童个人信息发生或者可能发生泄露、毁损、丢失的情形，将会立即启动应急预案，采取补救措施消减影响和控制损失，并将事件相关情况及时通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知影响的儿童及其父母或监护人。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >七、第三方责任说明</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、如您通过我们的网站或客户端，使用了由第三方而非提供的服务时，我们会尽力确保您的账号安全，使您获得更安全的访问体验，我们会使用专用的传输层安全协议，帮助您识别防范钓鱼、账号泄露等风险，同时更有利于保障您和第三方的共同权益，尽力阻止不法分子篡改您和您希望访问的第三方之间正常服务内容，确保您的个人信息在传输过程中的安全。</span
      >
    </p>
    <p>
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size: 12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >2</span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
            >、您通过我们客户端接入使用的第三方服务，查看第三方创建的网页或使用第三方开发的应用程序时，向您提示这些第三方可能会放置他们自己的Cookies，这些Cookies不受我们的控制，且它们的使用不受本政策的约束，您应当进行关注。我们对第三方服务提供方对您的个人信息采取保护措施会尽到法律规定的义务，但我们无法保证这些主体一定会按照我们的要求标准采取保护措施，如果您发现这些第三方服务存在风险时，建议您终止相关操作以保护您的合法权益。服务提供方应有自己的独立隐私权保护政策，您使用的第三方服务受其隐私政策约束，建议您仔细阅读其政策内容。</span
          ></span
        ></strong
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
          >八、本政策适用与修订</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >所有服务均适用本政策，我们的隐私政策可能因功能变更、业务变化、服务更新、监管要求等原因而随之修订。未经您明确同意，我们不会减少您按照本隐私政策所应享有的权利。我们会在网站、移动端上更新政策版本，同时在生效前通过网站公告资讯发布或以其他适当方式提醒您相关内容的更新。对于重大变更，我们还会提供更为显著的通知，包括但不仅限于短信通知、客户端消息中心等，说明隐私政策的具体变更内容，您可以通过客户端【我的】页签【设置】页面中的【账户与隐私】入口，访问阅读最新版的《隐私政策》。</span
      >
    </p>
    <p style="text-indent:28px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >本政策所指的重大变更包括但不限于：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、我们的服务模式发生重大变化。如处理个人信息的目的、类型及使用方式等；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、个人信息共享、转让或公开披露的主要对象发生变化；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、您参与个人信息处理方面的权利及其行使方式发生重大变化；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、我们负责处理个人信息安全的联络方式及投诉渠道发生变化时；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >5</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:black"
        >、个人信息安全影响评估报告以及敏感信息内部审计报告表明存在高风险时。</span
      >
    </p>
    <p>
      <br />
    </p>
  </div>
</template>
<script>
export default {
  name: "ServiceProtocol",
  components: {},
  props: {},
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
